<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.Base64Codec.title') }}</span>
      <span class="fmt-spacer"/>
      <el-tooltip :content="$t('tool.Base64Codec.urlSafeTip')" placement="bottom">
        <span :class="['uc-chip',{on:urlSafe}]" @click="urlSafe=!urlSafe">{{ $t('tool.Base64Codec.urlSafe') }}</span>
      </el-tooltip>
      <el-button size="small" icon="el-icon-sort" @click="encode">{{ $t('common.action.encode') }}</el-button>
      <el-button size="small" @click="decode">{{ $t('common.action.decode') }}</el-button>
      <el-button size="small" plain icon="el-icon-star-off" @click="loadSample">{{ $t('common.action.sample') }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doCopy">{{ $t('common.action.copy') }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t('common.action.clear') }}</el-button>
    </div>
    <el-input v-model="text" type="textarea" :rows="14"
      :placeholder="focused ? $t('tool.Base64Codec.phPasted') : $t('tool.Base64Codec.phInput')"
      class="fmt-textarea" @input="onInput" @focus="focused=true" @blur="focused=false"/>
    <div class="fmt-status-bar">
      <span v-if="errorMsg" class="fmt-err"><i class="el-icon-warning"/> {{ errorMsg }}</span>
      <span v-else-if="lastOp" class="fmt-ok"><i class="el-icon-circle-check"/> {{ lastOp }}</span>
      <span v-else-if="text.trim()" class="fmt-hint">{{ detectHint || $t('common.hint.charCount', { n: charCount }) }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.Base64Codec.hintEmpty') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'Base64CodecTool',props:{config:{type:Object,default:()=>({})}},
  data:function(){
    return { text:'', urlSafe:false, errorMsg:'', lastOp:'', detectHint:'', focused:false }
  },
  computed:{
    charCount:function(){ return this.text.length }
  },
  methods:{
    onInput:function(){
      this.errorMsg = ''; this.lastOp = ''; this.detectHint = ''
      if (this.text.trim()) {
        var looksLikeBase64 = /^[A-Za-z0-9+/=_-]+$/.test(this.text.trim()) && this.text.trim().length > 4
        this.detectHint = looksLikeBase64 ? this.$t('tool.Base64Codec.detectBase64') : this.$t('tool.Base64Codec.detectPlain')
      }
    },
    encode:function(){
      this.errorMsg = ''; this.lastOp = ''; this.detectHint = ''
      if (!this.text.trim()) return
      try {
        var bytes = new TextEncoder().encode(this.text)
        var binary = Array.from(bytes,function(b){return String.fromCharCode(b)}).join('')
        var b64 = btoa(binary)
        if (this.urlSafe) { b64 = b64.replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'') }
        this.text = b64
        this.lastOp = this.$t('tool.Base64Codec.msgEncoded', { n: this.text.length })
      } catch(e) { this.errorMsg = this.$t('tool.Base64Codec.msgEncodeFail', { msg: e.message }) }
    },
    decode:function(){
      this.errorMsg = ''; this.lastOp = ''; this.detectHint = ''
      if (!this.text.trim()) return
      try {
        var s = this.text.trim()
        // 自动还原 URL 安全格式
        s = s.replace(/-/g,'+').replace(/_/g,'/')
        // 补齐 padding
        while (s.length % 4) s += '='
        var binary = atob(s)
        var bytes = Uint8Array.from(binary,function(c){return c.charCodeAt(0)})
        this.text = new TextDecoder().decode(bytes)
        this.lastOp = this.$t('tool.Base64Codec.msgDecoded', { n: this.text.length })
      } catch(e) {
        this.errorMsg = this.$t('tool.Base64Codec.msgDecodeFail')
      }
    },
    loadSample:function(){ this.text = this.$t('tool.Base64Codec.sample'); this.errorMsg = ''; this.lastOp = ''; this.detectHint = '' },
    doCopy:function(){
      if (!this.text.trim()) { this.$message.warning(this.$t('common.status.noContent')); return }
      navigator.clipboard.writeText(this.text).then(this.$message.success(this.$t('common.status.copied')))
    },
    clearAll:function(){ this.text = ''; this.errorMsg = ''; this.lastOp = ''; this.detectHint = '' },
    doAction:function(a){
      if (a === 'copy') this.doCopy()
      if (a === 'clear') this.clearAll()
    }
  }
}
</script>

<style scoped>
.fmt-tool { display: flex; flex-direction: column; gap: 12px; }

.fmt-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.fmt-toolbar >>> .el-button + .el-button { margin-left: 0; }
.fmt-label { font-size: 13px; font-weight: 700; color: #1a1f36; }
.fmt-spacer { flex: 1; }

.uc-chip { padding: 5px 14px; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; color: #909399; background: #f0f2f5; transition: .12s; border: 1px solid transparent; }
.uc-chip:hover { color: #4e7cff; }
.uc-chip.on { background: #e8f0fe; color: #4e7cff; border-color: #4e7cff; }

.fmt-textarea >>> textarea {
  font-family: 'JetBrains Mono','Fira Code','Consolas',monospace !important;
  font-size: 13px !important; line-height: 1.6 !important;
  border-radius: 10px; resize: vertical; min-height: 280px;
}

.fmt-status-bar { font-size: 12px; }
.fmt-err { color: #f56c6c; display: flex; align-items: center; gap: 4px; }
.fmt-ok { color: #67c23a; display: flex; align-items: center; gap: 4px; }
.fmt-hint { color: #c0c4cc; }
</style>
